import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarCategoriaLcp116Prefeitura } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class CategoriaLcp116PrefeituraBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Categoria LCP 116 Prefeitura">
                    <DataGrid
                        dataSource={criarCategoriaLcp116Prefeitura()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'id'} caption={"#"} width={'80'} allowEditing={false} alignment={"center"} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'codigo'} caption={"Código"} />
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
